import { render, staticRenderFns } from "./generalHeader.vue?vue&type=template&id=bf8ff956&"
import script from "./generalHeader.vue?vue&type=script&lang=js&"
export * from "./generalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports